import axios from "axios";
import * as React from "react";
import * as md5 from "crypto-js/md5";
import * as sha512 from "crypto-js/sha512";

import { ReactNode } from "react";
import { CustomSnackbar } from "./component/shared/snackbar/CustomSnackbar";
import { getError } from "./services/ErrorService";

// tslint:disable-next-line:no-empty-interface
export interface IAuthContextData {
  signed: boolean;
  user: any;
  Login(user: object): Promise<void>;
  Logout(): void;
  setLoginData(data: any): void;
}

export const AuthContext = React.createContext<IAuthContextData>(
  {} as IAuthContextData
);

interface IProps {
  children: ReactNode;
}

export interface IState {
  isLogin: boolean;
  alert: {
    open: boolean;
    msg: string;
    type?: string;
  };
  user: any;
}

export class AuthProvider extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      alert: {
        msg: !!window.sessionStorage.getItem("expirado") ? 'Sua sessão expirou. Faça o login novamente!' : '',
        open: !!window.sessionStorage.getItem("expirado") ? true : false,
        type: "error",
      },
      isLogin: !!window.sessionStorage.getItem("token") ? true : false,
      user: { first_access: false },
    };
  }

  public encryptPass(value: string) {
    return sha512(md5(value).toString().toUpperCase()).toString().toUpperCase();
  }

  public Login = async (usuario: any) => {
    if (!usuario.password || !usuario.username) {
      this.openAlert("Os campos não podem estar em branco");
      return;
    }

    const HOST = process.env.API;
    const params = {
      password: this.encryptPass(usuario.password),
      username: usuario.username,
    };
    try {
      const response = await axios.post(`${HOST}auth/login`, params);
      if (response.data) {
        this.setLoginData(response.data);
      }
    } catch (err) {
      const erro = getError(err);
      this.openAlert(erro.message);
    }
  };

  public Logout = () => {
    window.sessionStorage.clear();
    this.setState({ isLogin: false, user: { first_access: false } });
    window.location.reload();
  };

  public render() {
    const { msg, open, type } = this.state.alert;
    const { isLogin } = this.state;
    return (
      <AuthContext.Provider
        value={{
          Login: this.Login,
          Logout: this.Logout,
          setLoginData: this.setLoginData,
          signed: isLogin,
          user: this.state.user,
        }}
      >
        <CustomSnackbar
          msg={msg}
          type={type}
          open={open}
          onClose={this.closeAlert}
        />
        {this.props.children}
      </AuthContext.Provider>
    );
  }

  private setLoginData = (data: any) => {
    const token = data.access_token;
    const user = data.user;
    window.sessionStorage.setItem("token", token);
    window.sessionStorage.setItem("user", JSON.stringify(user));
    window.sessionStorage.removeItem("expirado");
    this.setState({ isLogin: !!token, user });
  };

  private openAlert = (msg: string) => {
    this.setState({ alert: { msg, open: true } })
  }

  private closeAlert = () => {
    this.setState({ alert: { msg: "", open: false } });
  };
}



// WEBPACK FOOTER //
// ./src/auth.tsx